// ********* CSS & Images ******************** //

import '@styles/main.scss';
import "./faqs.css";

// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// ************ Add JS for Email Signup & Error Popup *************** //

import '../nav-header-footer/email-contact-new-classes.js';

// **************************** Loading Spinner ****************************** //

window.addEventListener('load', () => {
  const preloader = document.getElementById("preloader");
  if (preloader) {
    preloader.style.display = "block";
    setTimeout(() => {
      preloader.style.transition = "opacity 0.2s ease";
      preloader.style.opacity = 0;
      setTimeout(() => preloader.remove(), 200);
    }, 1000);
  }
});

// ******************** FAQs - Show More/Less Details ******************** //

document.addEventListener("DOMContentLoaded", () => {

  const questions = document.querySelectorAll('.question');

  questions.forEach((question) => {
    const answerContainer = question.querySelector('.question-answer');
    if (!answerContainer) return;

    const paragraphs = answerContainer.querySelectorAll('p');

    // Progressive disclosure: If an answer contains more than one paragraph
    if (paragraphs.length > 1) {
      // Create a wrapper div for all secondary paragraphs to hide/show cleanly
      const detailsWrapper = document.createElement('div');
      detailsWrapper.classList.add('remaining-details');

      // Move everything after the first paragraph into the details wrapper
      for (let i = 1; i < paragraphs.length; i++) {
        detailsWrapper.appendChild(paragraphs[i]);
      }

      // Create the "more details" link anchor object
      const moreDetailsLink = document.createElement('a');
      moreDetailsLink.href = '#';
      moreDetailsLink.classList.add('more-details-link');
      moreDetailsLink.textContent = 'read more';

      // Listen for inner "more details" click toggling
      moreDetailsLink.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation(); // Avoid triggering parent accordion close triggers

        const isExpanded = question.classList.toggle('show-all-details');
        moreDetailsLink.textContent = isExpanded ? 'show less' : 'read more';
      });

      // Append wrapper and action item to the parent container interface
      answerContainer.appendChild(detailsWrapper);
      answerContainer.appendChild(moreDetailsLink);
    }

    // Main Accordion expand/collapse click container binding
    const faqButton = question.querySelector('.question-text-div');
    faqButton.addEventListener('click', () => {
      questions.forEach((item) => {
        if (item !== question) {
          item.classList.remove('show-text');
          item.classList.remove('show-all-details');
          
          // Reset text counters on unrelated containers closing away
          const linkedBtn = item.querySelector('.more-details-link');
          if (linkedBtn) linkedBtn.textContent = 'read more';
        }
      });
      
      question.classList.toggle('show-text');
    });
  });
});

